import { ref } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useDistributionNavigationStore } from "../store/useDistributionNavigationStore";
import { useDistributionStore } from "../store/useDistributionStore";
import { useUpdateDistributionStore } from "../store/useUpdateDistributionStore";
export default {
  name: "UpdateDistributionModal",
  components: {
    LlSecondaryButton
  },
  setup() {
    const distributionNavigationStore = useDistributionNavigationStore();
    const distributionStore = useDistributionStore();
    const updateDistributionStore = useUpdateDistributionStore();
    const listDistributions = ref([]);
    const distribution = ref('');
    const {
      label,
      id
    } = distributionNavigationStore.updatedDistribution;
    distribution.value = label;
    listDistributions.value = distributionStore.distributionsList;
    const confirm = type => {
      if (id) {
        updateDistributionStore.updatePaymentDistribution({
          label: distribution.value,
          id
        });
      } else {
        updateDistributionStore.createPaymentDistribution({
          label: distribution.value
        }, type);
      }
      distributionNavigationStore.toggleUpdateDistributionModal(false, null);
    };
    return {
      confirm,
      distribution,
      listDistributions,
      distributionNavigationStore
    };
  }
};